import { render, staticRenderFns } from "./FormDateField.vue?vue&type=template&id=70556b06"
import script from "./FormDateField.vue?vue&type=script&lang=ts"
export * from "./FormDateField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports